import { render, staticRenderFns } from "./ksTab.vue?vue&type=template&id=141744aa&scoped=true"
import script from "./ksTab.vue?vue&type=script&lang=js"
export * from "./ksTab.vue?vue&type=script&lang=js"
import style0 from "./ksTab.vue?vue&type=style&index=0&id=141744aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141744aa",
  null
  
)

export default component.exports